const verifiedMessage = 'Your email address is now successfully linked to your {{ApplicationName}} account.';
const linkExpiredMessage =
  'Link is expired. Please send the email again from your {{ApplicationName}} account to verify.';
const notFoundMessage = 'Your email address is removed from {{ApplicationName}} account. Please add and verify again.';
const unknownErrorMessage = 'Unknown error occured. Please try again.';

export { verifiedMessage, linkExpiredMessage, notFoundMessage, unknownErrorMessage };
